export default "__VITE_ASSET__DK6mn5DM__"